module.exports = __webpack_public_path__ + "static/img/30016 (2).74657d7.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30016 (2).webp
// module id = Si1s
// module chunks = 14